import React, { useEffect } from 'react'
import CameraIcon from '../../elements/icons/CameraIcon'
import { calculateAge } from '../../../utils'
import StudentStatus from '../../elements/StudentStatus'
import { useDispatch, useSelector } from 'react-redux';
import { fetchStudentTraits } from '../../../store/actions/traitsActions';
import ChevronIcon from '../../elements/icons/ChevronIcon';

const StudentOverviewCard = ({student}) => {
    const dispatch = useDispatch()
    const traitsSelector = useSelector(state => state.traits) 

    useEffect(() => {
        dispatch(fetchStudentTraits(student._id))

        
    }, [student?._id, dispatch])

    const [collapsed, setCollapsed] = React.useState(false)
    
    return (
        <aside className='w-full overflow-hidden bg-white'>
            {collapsed && 
                <div className="w-full flex items-center gap-x-2 mb-3 relative">
                    <div className="w-[50px]">
                        <div className='flex h-[50px] w-[50px] rounded-xl items-center justify-center bg-gray-50' style={{
                            backgroundImage: `url(" ${student?.passportPhotograph} ")`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center center',
                            backgroundRepeat: 'none'
                        }}>
                            {(!student?.passportPhotograph || student?.passportPhotograph === '') &&
                                <CameraIcon className={`w-8 h-8 text-gray-200`} />
                            }
                        </div>
                    </div>

                    <div className="w-full">
                        <p className='font-space-grotesk text-base font-semibold text-gray-900'>
                            {`${student?.firstName || ''}${student?.otherNames ? ` ${student.otherNames.charAt(0)}.` : ''} ${student?.lastName || ''}`}
                            <span className='px-2 py-1 ml-1 bg-gray-100 rounded text-sm font-medium text-gray-900'>
                                {`${student?.class?.class?.name}${student?.class?.division?.label ? ` ${student?.class?.division?.label}` : ''}` || <span className='text-gray-400'>Not assigned</span>}
                            </span>
                        </p>
                        <p className='mt-1 text-xs uppercase tracking-[0.2em] text-vcm-dark-gray'>
                            {student?.admissionNumber || <span className='text-gray-400'>No student code</span>}
                        </p>
                    </div>
                    <button onClick={() => {setCollapsed(false)}} className='w-[150px] font-space-grotesk font-[600] text-xs absolute bottom-0 -right-3 text-gray-600 hover:text-gray-400 flex items-center justify-center gap-x-[5px]'>
                        See Details 
                        <ChevronIcon className={`w-4 h-4 transition duration-200 rotate-[270deg]`} />
                    </button>
                </div>
            }
            {!collapsed && 
                <div className="xl:hidden flex flex-row-reverse mb-4 w-full">
                    <button onClick={() => {setCollapsed(true)}} className='font-space-grotesk font-[600] text-xs  text-gray-600 hover:text-gray-400 flex items-center justify-center gap-x-[5px]'>
                        Collapse
                        <ChevronIcon className={`w-4 h-4 transition rotate-180 duration-200`} />
                    </button>
                </div>
            }

            {!collapsed && <div className='mx-auto flex h-[220px] w-full items-center justify-center bg-gray-50' style={{
                backgroundImage: `url(" ${student?.passportPhotograph} ")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'none'
            }}>
                {(!student?.passportPhotograph || student?.passportPhotograph === '') &&
                    <CameraIcon className={`w-8 h-8 text-gray-200`} />
                }
            </div>}

            {!collapsed && <div className='py-5'>
                <p className='font-space-grotesk text-base font-semibold text-gray-900'>
                    {`${student?.firstName || ''}${student?.otherNames ? ` ${student.otherNames.charAt(0)}.` : ''} ${student?.lastName || ''}`}
                </p>
                <p className='mt-1 text-xs uppercase tracking-[0.2em] text-vcm-dark-gray'>
                    {student?.admissionNumber || <span className='text-gray-400'>No student code</span>}
                </p>

                <div className='mt-5 rounded-lg bg-vcm-light-purple/20 p-3'>
                    <p className='text-xs text-vcm-dark-gray'>Current class</p>
                    <p className='mt-1 text-sm font-medium text-gray-900'>
                        {`${student?.class?.class?.name}${student?.class?.division?.label ? ` ${student?.class?.division?.label}` : ''}` || <span className='text-gray-400'>Not assigned</span>}
                    </p>
                </div>

                <div className='mt-3 grid grid-cols-2 gap-3'>
                    <div className='rounded-lg border border-gray-100 p-3'>
                        <p className='text-xs text-vcm-dark-gray'>Gender</p>
                        <p className='mt-1 capitalize text-sm font-medium text-gray-900'>
                            {student?.gender?.toLowerCase() || 'Not provided'}
                        </p>
                    </div>
                    <div className='rounded-lg border border-gray-100 p-3'>
                        <p className='text-xs text-vcm-dark-gray'>Age</p>
                        <p className='mt-1 font-space-grotesk text-sm font-medium text-gray-900'>
                            {student?.dob ? calculateAge(student?.dob) : 'Not provided'}
                        </p>
                    </div>
                </div>

                <div className='mt-3 rounded-lg border border-gray-100 p-3'>
                    <p className='text-xs text-vcm-dark-gray'>Status</p>
                    <div className='mt-1'>
                        <StudentStatus status={student?.status} />
                    </div>
                </div>

                <div className='mt-3 rounded-lg border border-gray-100 p-3'>
                    <div className="flex items-center justify-between gap-x-5 pb-2 border-b border-gray-100">
                        <p className='text-xs text-vcm-dark-gray '>Traits</p>
                    </div>
                    <div className='mt-1'>
                        {traitsSelector?.loadingStudentTraits ?
                            <p className="text-xs text-gray-400">Loading traits...</p>
                        :
                            traitsSelector?.studentTraits?.traits?.length > 0 ?
                                <div className=''>
                                    {traitsSelector?.studentTraits?.traits?.map((trait, index) => (
                                        <div key={index} className="mb-2">
                                            <div className='py-1 text-xs font-medium text-vcm-purple flex items-center justify-between mb-1'>
                                                <p>
                                                    {trait.trait.name}
                                                </p>
                                                <p>{trait.score}</p>
                                            </div>
                                            <div className='h-1 bg-gray-200 rounded w-full'>
                                                <div className={`h-1 rounded-full ${trait.score > 10 || trait.score < 5 ? 'bg-red-600' : trait.score < 7 && trait.score >= 5 ? 'bg-yellow-500' : 'bg-green-500'}`} style={{ 
                                                    width: `${trait.score * 10}%`,
                                                }}></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            :
                                <p className="text-xs text-gray-400">No traits information provided yet.</p>
                        }
                    </div>
                </div>
            </div>}
        </aside>
    )
}

export default StudentOverviewCard